import React, { useEffect, useState, useCallback } from 'react'
import Modal from 'react-responsive-modal'
import Button from '../../components/Button'
import Confirmation from '../../components/Confirmation/Confirmation'
import styles from './styles.module.css'
import { useFormik } from 'formik'
import { Input } from '../../components/ModalInputs'
import { useDispatch } from 'react-redux'
import { createPermissionGroup, updatePermissionGroup } from '../../actions/permissions'
import * as Yup from 'yup'

const validationSchema = Yup.object({
  name: Yup.string().trim().max(60, 'Название не более 60 символов').required('обязательное поле')
})

export default function RoleModal ({
    open,
    closeModal,
    data,
    addMode
}) {
  const [confirmation, setConfirmation] = useState(false)

  useEffect(()=> handleReset ,[open])

  const modalTitle = data?.name || 'Добавление роли'

  const dispatch = useDispatch()

  const updateGroup = ({pmid, name}) => {
    const payload = { name }
    if(payload.name.length>0){
      dispatch(updatePermissionGroup(pmid, payload))
      closeModal()
    }
  }
  
  const createGroup = (values) => {
    dispatch(createPermissionGroup(values))
    closeModal()
    
  }

  const {
    values,
    errors,
    touched,
    dirty,
    handleBlur,
    handleChange,
    handleSubmit,
    handleReset
  } = useFormik({
    initialValues: data || {},
    enableReinitialize: true,
    validateOnChange: true,
    validationSchema: validationSchema,
    onSubmit: addMode ? createGroup : updateGroup,

  })
  const error = (fieldName) => (touched[fieldName]) && errors[fieldName]

  const handleCloseModal = useCallback(() => {
    if (dirty) {
      setConfirmation(true)
    } else {
      closeModal()
    }
  }, [dirty, closeModal])

  const acceptConfirmation = useCallback(() => {
    closeModal()
    setConfirmation(false)
  }, [closeModal])

  const rejectConfirmation = useCallback(() => {
    setConfirmation(false)
  }, [])

 
  return (
    <Modal
        open={open}
        onClose={handleCloseModal}
        closeOnOverlayClick={true}
        closeOnEsc={true}
        showCloseIcon={false}
        animationDuration={1}
        classNames={{
            modal: styles.modal
        }}
    >
        <header>{modalTitle}</header>
        <main>
          <Input
            label='Название'
            name='name'
            value={values.name}
            error={error('name')}
            onChange={handleChange}
            onBlur={handleBlur}
            maxLength={60}
          />
          <p className={styles.hint}>Название не более 60 символов</p>
        </main>
        <footer className={styles.footer}>
            <Button mode='white' onClick={handleSubmit}>Сохранить</Button>
            <Button mode='white' onClick={handleCloseModal}>Закрыть</Button>
        </footer>

        {confirmation && (
          <Confirmation
            title="Есть несохраненные данные. Уверены что хотите выйти?"
            acceptConfirmation={acceptConfirmation}
            rejectConfirmation={rejectConfirmation}
          />
        )}
    </Modal>
  )
}
